<template>
  <div v-loading="fullScreenLoading">
    <el-form ref="form" :model="model"  :rules="rules" position="top">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="text-center">
          <el-row>
            <el-col class="formContainer" >
              <el-upload
                v-if="asset==null && !fullScreenLoading"
                drag
                :action="uploadURL"
                :before-upload="beforeUpload"
                :multiple=false
                :http-request="uploadFile"
                :file-list="file">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Déposer le fichier ici ou <em>cliquez pour parcourir</em></div>
                <div class="el-upload__tip" slot="tip">Images/videos avec une taille inférieure à 10mo</div>
              </el-upload>

            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="asset!=null">
          <div class="item " >
            <img  v-lazy="asset.secure_url" alt="card image">
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="asset!=null">
          <el-row class="m-20">
            <el-col class="text-center">
              <el-button @click="close">Annuler</el-button>
              <el-button v-if="!isEditionMode" type="primary" @click="save('save')">Ajouter</el-button>
              <el-button v-if="isEditionMode" type="primary" @click="save('edit')">Modifier</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="Bibliothèque" prop="type_id">
                <el-select v-model="model.type_id" placeholder="Select" width="200">
                   <el-option
                     width="200px"
                     v-for="item in types"
                     :key="item.id"
                     :label="item.name[lang]"
                     :value="item.id">
                   </el-option>
                 </el-select>
               </el-form-item>
             </el-col>
            <el-col>
               <el-form-item label="Nom">
                  <el-input v-model="model.code"></el-input>
                </el-form-item>
             </el-col>
             <el-col>
               <span class="fs-14">Taille : {{asset.width}}x{{asset.height}}</span>
             </el-col>
             <el-col>
               <span class="fs-14">Taille Thumbnail: {{asset.eager[0].width}}x{{asset.eager[0].height}}</span>
             </el-col>
             <el-col>
               <el-form-item>
                 <span>Description</span>
                 <el-tabs v-model="languageTabs" type="border-card">
                   <el-tab-pane v-for="l in cms_languages" :key="l.id" :label="l.name" :name="l.code">
                     <quill-editor v-model="model.description[l.code]" style="margin-top:40px;border:1px solid #EBEEF5;min-height:200px;"
                       ref="noteEditor"
                       :options="editorOptions">
                     </quill-editor>
                   </el-tab-pane>
                 </el-tabs>
                </el-form-item>
             </el-col>
           </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>

import axios from 'axios'
import cmsAPI from '@/services/API/cmsAPI'
import imageUtil from '@/utils/image-util.js'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'image-editor-controller',
	props: {
		dialogVisible : {type : Boolean, default:false},
    assetToEdit : Object,
    types : Array,
    preSelectedType : Number,
	},
  data() {
    return {
      file  : [],
      fullScreenLoading : false,
      model : {
        assetId : null,
        thumbnailLink : null,
        link : null,
        type_id : null,
        description : {},
        code : null,
      },
      selectedType : null,
      asset : null,
      languageTabs : "fr",
      editorOptions: {
				theme: 'bubble',
        placeholder:"Saisir une description",
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike']
					]
				}
			},
      rules : {
        type_id : [
          { required: true, message: 'Veuillez saisir une bibliothèque', trigger: 'blur' }
        ]
      }
    };
  },components: {

  },
	methods: {
    beforeUpload(){
      this.fullScreenLoading=true;
    },
    resetFields(){
      this.model.file = [];
      this.asset = null;
      this.model.assetId = null;
      this.model.link = null;
      this.model.thumbnailLink = null;
      this.model.type_id = null;
      this.initDescription();
      this.model.code = null;
      this.$refs.form.resetFields();
      this.languageTabs = "fr";
    },
    buildGalleryObjectModel(){
      return {
        assetId : this.model.assetId,
        thumbnailLink : this.model.thumbnailLink,
        assetInfo : this.asset,
        link : this.model.link,
        type : {
          id : this.model.type_id
        },
        code : this.model.code,
        description : this.model.description
      }
    },
    save(action){

      this.fullScreenLoading = true;
      let gallery = this.buildGalleryObjectModel();

      if(action=='save'){
        return cmsAPI.saveGallery(gallery)
          .then(galleryCreated=>{
            this.$message.success("L'image a été sauvegardé avec succès!");
            this.$emit('created',galleryCreated);
            this.close();
            this.fullScreenLoading = false
          }).catch(err=>{
            this.fullScreenLoading = false;
            this.$message.error("Une erreur est survenue. Veuillez réessayer plus tard.");
          })
      }
    },
    handleUploadSuccess(response){
      this.fullScreenLoading = false;
      this.asset = response.data;
      this.model.link = this.asset.secure_url;
      this.model.assetId = this.asset.asset_id;
      this.model.thumbnailLink = this.asset.eager!=null && this.asset.eager.length>0 ? this.asset.eager[0].secure_url : null;
      this.initDescription();
      if(this.model.code==null)this.model.code = this.asset.original_filename;
    },
    handleUploadError(err){
      this.fullScreenLoading = false;
      this.$message.error('Une erreur est survenue lors lors du téléversement du fichier... Veuillez réessayer plus tard.');
    },
    uploadFile(uploadForm){
      this.fullScreenLoading = true;
      return imageUtil.uploadFile(uploadForm.file, this.handleUploadSuccess, this.handleUploadError)
    },
    initDescription(){
      _.forEach(this.cms_languages, l=>{
        this.model.description[l.code] = '';
      })
    },
    open(){
      if(this.preSelectedType!=null && this.preSelectedType!=-1)this.model.type_id = this.preSelectedType;
      this.initDescription();
    },

    close(){

      this.$emit('close');
      this.resetFields();

    },
    ...mapActions('controlData',['fetchLanguages']),
	},
	computed: {
    cms_languages(){
      return _.filter(this.languages, l=>{return l.cms_language});
    },
    lang(){
      return this.$i18n.locale
    },
    uploadURL(){
       return process.env.VUE_APP_CLOUDINARY_URL;
    },
    isEditionMode(){
      return this.itemToEdit!=null;
    },
    ...mapState('controlData',['languages']),
	},
  watch : {
      dialogVisible : function(val){
        // console.log("watch dialogVisible : ", val);
        if(val==true){
          this.open();
        }
      }
  },
  created(){
    this.fetchLanguages();
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';


.el-form-item{
  margin-bottom:20px;
}


  // .dialog-footer{
  //   position: fixed;
  //   display: block;
  //   bottom: 0px;
  //   width: 100%;
  //   background-color: #f3f7fa;
  //   height:50px;
  //   margin-left:-20px;
  //   padding-top:10px;
  //   border-top:1px solid #E4E7ED;
  //   z-index:100;
  // }

  .item {
    //padding: 20px;
    //margin: 20px 0;
    margin-bottom: 20px;
    //border-radius: 5px;
    // opacity: .85;
    transition: all .25s;

    /* masonry */
    //display: inline-block;
    box-sizing: border-box;
    width: 100%;

    img {
      width: 100%;
      max-width: 100%;
      opacity: 1;
      box-shadow: 0px 0px 0px 2px $text-color-accent;
    }

    // &:hover {
    //   cursor:pointer;
    //   opacity: 1;
    //   box-shadow: 0px 0px 0px 4px $text-color-accent;
    // }
  }

@media (max-width: 1366px) {
  .el-col-xs-24{
      margin-left:15%;
      width:60%;
    }
}

@media (max-width: 1080px) {
  .el-col-xs-24{
      margin-left:2%;
      width:100%;
    }
  }
</style>
